import { BlogVisibilityTypes } from "./blog.dto";

export enum T_Category_Type {
  CUSTOMER_STORY = "CUSTOMER_STORY",
  BLOG = "BLOG",
  TESTIMONIAL = "TESTIMONIAL",
}
export type T_Category = {
  _id: string;
  slug: string;
  title: string;
  description: string;
  icon: string;
  type: keyof typeof T_Category_Type;
  visbility_type: keyof typeof BlogVisibilityTypes;
  blogCount: number;
  createdAt: string;
  updatedAt: string;
};

export type T_UpdateBlog = {
  slug?: string;
  title: string;
  description: string;
  icon?: string;
  type?: keyof typeof T_Category_Type;
  visbility_type?: keyof typeof BlogVisibilityTypes;
};
